import { Values } from '../utils/types';

export const EQUIPMENT_CONSTANTS = {
  FORM: {
    WIDTH_INPUT_POPOVER_TEXT: 'Non disponible pour un tracteur ou une remorque',
  },
  TYPES: {
    andaineuse: 'andaineuse',
    broy: 'broy',
    charrue: 'charrue',
    chenillard: 'chenillard',
    coupe: 'coupe',
    enjambeur: 'enjambeur',
    epand: 'epand',
    faneuse: 'faneuse',
    faucheuse: 'faucheuse',
    haymaking: 'haymaking',
    intercep: 'intercep',
    lisier: 'lisier',
    misc: 'misc',
    plomb: 'plomb',
    presse: 'presse',
    pulve: 'pulve',
    recolt: 'recolt',
    recolt_tool: 'recolt_tool',
    remork: 'remork',
    semoir: 'semoir',
    semoir_couverts: 'semoir_couverts',
    snow_removal: 'snow_removal',
    sol_combined: 'sol_combined',
    sol: 'sol',
    tractor: 'tractor',
    traitement: 'traitement',
    vendange: 'vendange',
    weeding: 'weeding',
  },
  CATEGORIES: {
    grande_culture: [
      'andaineuse',
      'broy',
      'charrue',
      'epand',
      'faneuse',
      'faucheuse',
      'haymaking',
      'lisier',
      'misc',
      'plomb',
      'presse',
      'pulve',
      'recolt',
      'remork',
      'semoir',
      'sol_combined',
      'sol',
      'tractor',
    ],
    viticulture: [
      'broy',
      'chenillard',
      'charrue',
      'coupe',
      'enjambeur',
      'epand',
      'intercep',
      'misc',
      'remork',
      'semoir',
      'sol_combined',
      'tractor',
      'traitement',
      'vendange',
      'weeding',
    ],
    deneigement: ['snow_removal'],
  },
  BILLING_METHODS: {
    DISTANCE: 'DISTANCE',
    DISTANCE_IN_FIELD: 'DISTANCE_IN_FIELD',
    DISTANCE_OUT_FIELD: 'DISTANCE_OUT_FIELD',
    AREA: 'AREA',
    TIME: 'TIME',
    TIME_MOVEMENT: 'TIME_MOVEMENT',
    TIME_IN_FIELD: 'TIME_IN_FIELD',
    TIME_OUT_FIELD: 'TIME_OUT_FIELD',
    DURATION: 'DURATION',
    UNIT: 'UNIT',
    FUEL: 'FUEL',
    FUEL_IN_FIELD: 'FUEL_IN_FIELD',
    FUEL_OUT_FIELD: 'FUEL_OUT_FIELD',
  },
  GPIO_METHODS: {
    UNIT: 'unit',
    TIME: 'time',
  },
  EQUIPMENT_PAGE: {
    TAB: {
      SESSIONS: 'sessions',
      CONSUMPTIONS: 'consumptions',
      MAINTENANCE: 'maintenance',
      OBSERVATIONS: 'observations',
    },
  },
  EQUIPMENT_STATUS: {
    AVAILABLE: 'AVAILABLE',
    INUSE: 'IN_USE',
    ARCHIVED: 'ARCHIVED',
  },
} as const;

export const EQUIPMENT_BOOKING_STATUS = {
  PENDING: 'pending',
  ACCEPTED: 'accepted',
  REFUSED: 'refused',
  DELETED: 'deleted',
} as const;
export type EquipmentBookingStatus = Values<typeof EQUIPMENT_BOOKING_STATUS>;

export const EQUIPMENT_MAINTENANCE_CATEGORY = {
  ROUTINE: 'routine',
  REPAIR: 'repair',
  INSPECTION: 'inspection',
  WEAR_PART: 'wear_part',
  OTHER: 'other',
} as const;
export type EquipmentMaintenanceCategory = Values<typeof EQUIPMENT_MAINTENANCE_CATEGORY>;

export type EquipmentModel = Values<typeof EQUIPMENT_CONSTANTS.TYPES>;
export type EquipmentStatus = Values<typeof EQUIPMENT_CONSTANTS.EQUIPMENT_STATUS>;
export type EquipmentBillingMethod = Values<typeof EQUIPMENT_CONSTANTS.BILLING_METHODS>;
export type EquipmentGpioMethod = Values<typeof EQUIPMENT_CONSTANTS.GPIO_METHODS>;

export const BILLING_METHOD_TO_PROPERTY_NAME = {
  [EQUIPMENT_CONSTANTS.BILLING_METHODS.AREA]: 'area',
  [EQUIPMENT_CONSTANTS.BILLING_METHODS.TIME]: 'motorDuration',
  [EQUIPMENT_CONSTANTS.BILLING_METHODS.TIME_IN_FIELD]: 'inParcelMotorDuration',
  [EQUIPMENT_CONSTANTS.BILLING_METHODS.TIME_OUT_FIELD]: 'outParcelMotorDuration',
  [EQUIPMENT_CONSTANTS.BILLING_METHODS.TIME_MOVEMENT]: 'movementDuration',
  [EQUIPMENT_CONSTANTS.BILLING_METHODS.DURATION]: 'duration',
  [EQUIPMENT_CONSTANTS.BILLING_METHODS.DISTANCE]: 'distance',
  [EQUIPMENT_CONSTANTS.BILLING_METHODS.DISTANCE_IN_FIELD]: 'inParcelDistance',
  [EQUIPMENT_CONSTANTS.BILLING_METHODS.DISTANCE_OUT_FIELD]: 'outParcelDistance',
  [EQUIPMENT_CONSTANTS.BILLING_METHODS.UNIT]: 'unit',
  [EQUIPMENT_CONSTANTS.BILLING_METHODS.FUEL]: 'fuel',
  [EQUIPMENT_CONSTANTS.BILLING_METHODS.FUEL_IN_FIELD]: 'inParcelFuel',
  [EQUIPMENT_CONSTANTS.BILLING_METHODS.FUEL_OUT_FIELD]: 'outParcelFuel',
} as const;

export const getEquipmentTypesList = () =>
  Object.values(EQUIPMENT_CONSTANTS.TYPES).filter((type) => type !== EQUIPMENT_CONSTANTS.TYPES.semoir_couverts);
